import React from 'react';
import { connect } from 'react-redux';

import LoginForm from '../../components/forms/LoginForm';

import * as loginActions from '../../actions/login/LoginActions';

import './LoginContainer.css';

class LoginContainer extends React.Component {
  login = ({ email, password }) => {
    const { login } = this.props;
    login(email, password);
  };

  render() {
    const { auth } = this.props;
    return (
      <div className="App-main">
        <div className="Login-container Card">
          <LoginForm onSubmit={this.login} auth={auth} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps, loginActions)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/public/LoginContainer.js